export function discountValue(val, discount_percent) {
  let original_val = parseFloat(val);
  let discounted_amount = original_val * (parseFloat(discount_percent)/100);
  return (original_val - discounted_amount);
}
